import { GipReportValues } from '../form/types';

/**
 * Checks if the dates are disabled for the report when
 * custom field key is nocontrato or nocontratonacional for MVS client
 * or when the fixed date range is true
 */
export function areDatesDisabledForReport(values: GipReportValues): boolean {
  return (
    values._fixedDateRange ||
    ((values.customFieldKey?.name === 'nocontrato' ||
      values.customFieldKey?.name === 'nocontratonacional') &&
      !!values.customFieldValue)
  );
}
